__turbopack_context__.v({
  "button": "object-viewer-button-module-scss-module__18KYtW__button",
  "icon": "object-viewer-button-module-scss-module__18KYtW__icon",
  "noWrap": "object-viewer-button-module-scss-module__18KYtW__noWrap",
  "text": "object-viewer-button-module-scss-module__18KYtW__text",
});
